import token from "./token";
import React  from 'react';
import { Route, Redirect } from 'react-router-dom';

export default ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
        token.get() ?
            <Component {...props} />
            : <Redirect to='/auth' />
    )} />
);